import { CSSObject } from '@chakra-ui/react';
import { IS_MOBILE_APP } from '../../../../constants/isMobileApp';

export const Heading: CSSObject = {
  fontSize: IS_MOBILE_APP ? 'md' : '2xl',
};
